import axios from "axios";
import env from "../env";

export const getSigninSlides = async (i18n) => {
  let response = await axios.request({
    baseURL: env.REACT_APP_API_ENDPOINT,
    url: "core/content/signin",
  });
  return response;
};